module.exports = __webpack_public_path__ + "img/step19_a_stand_power_fix_stacker_supports.41b5dd7f.png";